import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";
import {MasterDataRepository} from "@/modules/masterData/adapter/MasterDataRepository";
import axios from "axios";

export class MasterDataRestRepository implements MasterDataRepository {
    private readonly auth: AuthenticationProvider;
    private masterDataList= [{
        "LABEL" : "Kundentypen",
        "ICON" : "ordermanager-people-customers",
        "GRIDNAME" : "BROWSE_KUNDENTYPEN",
        "FORMNAME" : "",
        "DISABLED" : false
    },
        {
            "LABEL" : "Zahlungsbedingungen",
            "ICON" : "ordermanager-settings",
            "GRIDNAME" : "BROWSE_ZAHLUNGSBEDINGUNGEN",
            "FORMNAME" : "",
            "DISABLED" : false
        },
        {
            "LABEL" : "Preiskategorien",
            "ICON" : "ordermanager-tag-price-euro",
            "GRIDNAME" : "BROWSE_PREISKATEGORIEN",
            "FORMNAME" : "",
            "DISABLED" : false
        },
        {
            "LABEL" : "Warengruppen",
            "ICON" : "ordermanager-types",
            "GRIDNAME" : "BROWSE_WARENGRUPPEN",
            "FORMNAME" : "",
            "DISABLED" : false
        },
        {
            "LABEL" : "Artikel-Einheiten",
            "ICON" : "ordermanager-settings",
            "GRIDNAME" : "BROWSE_EINHEITEN",
            "FORMNAME" : "",
            "DISABLED" : false
        },
        {
            "LABEL" : "Allergene",
            "ICON" : "ordermanager-danger",
            "GRIDNAME" : "BROWSE_ALLERGENE",
            "FORMNAME" : "",
            "DISABLED" : false
        },
        {
            "LABEL" : "Organisationseinheiten",
            "ICON" : "ordermanager-sitemap",
            "GRIDNAME" : "BROWSE_ORGANISATIONSEINHEITEN",
            "FORMNAME" : "",
            "DISABLED" : false
        },
        {
            "LABEL" : "Auswertungsgruppen",
            "ICON" : "ordermanager-charts",
            "GRIDNAME" : "BROWSE_AUSWERTUNGSGRUPPEN",
            "FORMNAME" : "",
            "DISABLED" : false
        },
        {
            "LABEL" : "Speditionen + Touren",
            "ICON" : "ordermanager-delivery",
            "GRIDNAME" : "BROWSE_SPEDITIONEN",
            "FORMNAME" : "",
            "DISABLED" : false
        }
    ];
    public static masterDataItems: any[];

    constructor(auth: AuthenticationProvider) {
        this.auth = auth;
    }

    public getGridList(): any[] {
        const sid = this.auth.getAuthToken();
        const user = this.auth.getUserId();

        if (sid) {
            const tabs = [];
            const apiTabs = this.masterDataList;
            for (let i = 0; i < apiTabs.length; i++) {
                tabs.push({
                    id: i,
                    route: `/stammdaten/${i}`,
                    name: apiTabs[i].LABEL,
                    icon: apiTabs[i].ICON,
                    gridName: apiTabs[i].GRIDNAME,
                    formName: apiTabs[i].FORMNAME,
                    context:""
                })
            }

            return tabs;
            // const response = await axios.post(`${this.auth.getServiceUrl()}/Stammdaten/Stammdaten_GetGridList`, {
            //     SID: sid,
            //     UserId: user
            // });
            // if (response.data.Stammdaten_GetGridList_response?.ServiceErrors) {
            //     throw new Error(response.data.Stammdaten_GetGridList_response.ServiceErrors[0].ERRORRECOMMENDATION);
            // } else {
            //     const tabs = new Array();
            //     const apiTabs = response.data.Stammdaten_GetGridList_response;
            //     for (let i = 0; i < apiTabs.length; i++) {
            //         tabs.push({
            //             id: i,
            //             route: `/stammdaten/${i}`,
            //             name: apiTabs[i].LABEL,
            //             icon: apiTabs[i].ICON,
            //             gridName: apiTabs[i].GRIDNAME,
            //             formName: apiTabs[i].FORMNAME,
            //         })
            //     }
            //
            //     return tabs;
            }
        return [];
        }

    public async getDateList(hauptauftrag:number):Promise<any[]> {
        const sid = this.auth.getAuthToken();
        const user = this.auth.getUserId();
        if (sid) {
            const data = {
                SID: sid,
                Hauptauftrag: hauptauftrag
            }
            const response = await axios.post(`${this.auth.getServiceUrl()}/Filialbestellungen/get_Datumsliste`, data);

            if (response.data.get_Datumsliste_response?.ServiceErrors) {
                throw new Error(response.data.get_Datumsliste_response.ServiceErrors[0].ERRORRECOMMENDATION);
            }else {
                return response.data.get_Datumsliste_response.dateslist;
            }

            return [];
        } else {
            return Promise.reject();
        }
    }
}
